function initMenuSidebar() {
  var sidebar = document.querySelector('[data-menu-sidebar]');
  if (!sidebar || sidebar.dataset.initialized === 'true') return;
  sidebar.dataset.initialized = 'true';

  var triggers = document.querySelectorAll('[data-menu-sidebar-open]');
  var panels = sidebar.querySelectorAll('[data-sidebar-panel].menu-sidebar__content');
  var closeEls = sidebar.querySelectorAll('[data-menu-sidebar-close]');
  var activeTrigger = null;

  function setActiveTab(panelIndex, tabIndex) {
    var tabs = sidebar.querySelectorAll('.menu-sidebar__tab[data-sidebar-panel="' + panelIndex + '"]');
    var lists = sidebar.querySelectorAll('.menu-sidebar__list[data-sidebar-panel="' + panelIndex + '"]');

    tabs.forEach(function (tab, index) {
      var isActive = index === tabIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    lists.forEach(function (list, index) {
      var isActive = index === tabIndex;
      list.classList.toggle('is-active', isActive);
      list.hidden = !isActive;
    });
  }

  function openSidebar(panelIndex, trigger) {
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-sidebar-panel') === String(panelIndex);
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
      if (isActive) setActiveTab(panelIndex, 0);
    });

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.closest('.menu__item')?.classList.remove('is-visible');
    }

    activeTrigger = trigger;
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'true');
      activeTrigger.closest('.menu__item')?.classList.add('is-visible');
    }

    sidebar.classList.add('is-open');
    sidebar.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('menu-sidebar-open');
  }

  function closeSidebar() {
    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('menu-sidebar-open');

    panels.forEach(function (panel) {
      panel.hidden = true;
      panel.classList.remove('is-active');
    });

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.closest('.menu__item')?.classList.remove('is-visible');
      activeTrigger = null;
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var panelIndex = trigger.getAttribute('data-menu-sidebar-open');
      var isOpen = sidebar.classList.contains('is-open') && activeTrigger === trigger;
      if (isOpen) {
        closeSidebar();
      } else {
        openSidebar(panelIndex, trigger);
      }
    });
  });

  sidebar.querySelectorAll('[data-menu-sidebar-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var panelIndex = tab.getAttribute('data-sidebar-panel');
      var tabIndex = parseInt(tab.getAttribute('data-menu-sidebar-tab'), 10) || 0;
      setActiveTab(panelIndex, tabIndex);
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeSidebar);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sidebar.classList.contains('is-open')) {
      closeSidebar();
    }
  });
}

function initDrawerTabsPanelSlide() {
  var drawer = document.querySelector('.drawer--header');
  if (!drawer || drawer.dataset.tabsSlideBound === 'true') return;
  drawer.dataset.tabsSlideBound = 'true';

  function resetTabsPanels() {
    drawer.querySelectorAll('.sliderule__panel--tabs').forEach(function (panel) {
      panel.classList.remove('is-hiding');
      panel.style.transform = '';
    });
  }

  document.addEventListener('theme:sliderule:close', resetTabsPanels);
}

function initDrawerMenuTabs() {
  var roots = document.querySelectorAll('[data-drawer-menu-tabs]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.drawerTabsBound === 'true') return;
    root.dataset.drawerTabsBound = 'true';

    root.querySelectorAll('[data-drawer-menu-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = tab.getAttribute('data-drawer-menu-panel');
        var tabIndex = parseInt(tab.getAttribute('data-drawer-menu-tab'), 10) || 0;
        var tabs = root.querySelectorAll('[data-drawer-menu-tab][data-drawer-menu-panel="' + panelId + '"]');
        var lists = root.querySelectorAll('[data-drawer-menu-list][data-drawer-menu-panel="' + panelId + '"]');

        tabs.forEach(function (item, index) {
          var isActive = index === tabIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        lists.forEach(function (list, index) {
          var isActive = index === tabIndex;
          list.classList.toggle('is-active', isActive);
          list.hidden = !isActive;
        });
      });
    });
  });
}

function initFooterMenuCollapsibles() {
  var menus = document.querySelectorAll('[data-footer-menu-collapsible]');
  if (!menus.length) return;

  var mq = window.matchMedia('(max-width: 750px)');

  function setDesktopState() {
    menus.forEach(function (menu) {
      var toggle = menu.querySelector('[data-footer-menu-toggle]');
      menu.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function onToggle(event) {
    if (!mq.matches) return;

    var toggle = event.currentTarget;
    var menu = toggle.closest('[data-footer-menu-collapsible]');
    if (!menu) return;

    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  menus.forEach(function (menu) {
    var toggle = menu.querySelector('[data-footer-menu-toggle]');
    if (!toggle) return;

    menu.classList.add('js-collapsible');

    if (toggle.dataset.footerMenuBound === 'true') return;
    toggle.dataset.footerMenuBound = 'true';
    toggle.addEventListener('click', onToggle);
  });

  function onBreakpointChange() {
    if (!mq.matches) setDesktopState();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onBreakpointChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onBreakpointChange);
  }

  onBreakpointChange();
}

function syncMobileDrawerOffset() {
  var header = document.querySelector('.theme__header');
  if (!header) return;
  var bottom = Math.round(header.getBoundingClientRect().bottom);
  document.documentElement.style.setProperty('--mobile-drawer-top', bottom + 'px');
}

function initMobileNavDropdowns() {
  var drawers = document.querySelectorAll('.drawer--header');
  if (!drawers.length) return;

  syncMobileDrawerOffset();
  window.addEventListener('resize', syncMobileDrawerOffset);

  drawers.forEach(function (drawer) {
    if (drawer.dataset.mobileNavAccordion === 'true') return;
    drawer.dataset.mobileNavAccordion = 'true';

    drawer.addEventListener('theme:drawer:open', syncMobileDrawerOffset);
    document.addEventListener('theme:drawer:open', syncMobileDrawerOffset);

    drawer.addEventListener('click', function (event) {
      var summary = event.target.closest('.mobile-nav-dropdown__summary');
      if (!summary || !drawer.contains(summary)) return;

      var details = summary.parentElement;
      if (!details || !details.classList.contains('mobile-nav-dropdown')) return;

      var panel = details.querySelector(':scope > .mobile-nav-dropdown__panel');
      if (!panel) return;

      event.preventDefault();

      if (details.open || details.classList.contains('is-open')) {
        closeMobileNavDropdown(details, panel);
      } else {
        openMobileNavDropdown(details, panel);
      }
    });
  });
}

function openMobileNavDropdown(details, panel) {
  details.open = true;
  details.classList.add('is-open');
  panel.style.height = '0px';

  requestAnimationFrame(function () {
    panel.style.height = panel.scrollHeight + 'px';
  });

  var onEnd = function (event) {
    if (event.propertyName !== 'height') return;
    panel.removeEventListener('transitionend', onEnd);
    if (details.open) {
      panel.style.height = 'auto';
    }
  };

  panel.addEventListener('transitionend', onEnd);
}

function closeMobileNavDropdown(details, panel) {
  details.classList.remove('is-open');
  panel.style.height = panel.scrollHeight + 'px';

  requestAnimationFrame(function () {
    panel.style.height = '0px';
  });

  var onEnd = function (event) {
    if (event.propertyName !== 'height') return;
    panel.removeEventListener('transitionend', onEnd);
    details.open = false;
    panel.style.height = '0px';
  };

  panel.addEventListener('transitionend', onEnd);
}

document.addEventListener("DOMContentLoaded", function() {
  initMenuSidebar();
  initDrawerTabsPanelSlide();
  initDrawerMenuTabs();
  initMobileNavDropdowns();
  initFooterMenuCollapsibles();
  // 1. Seleccionamos todos los radio buttons de despacho
  const radios = document.querySelectorAll('input[name="enova-despacho"]');
  
  // 2. Función para actualizar qué texto se muestra
  function updateDespachoInfo() {
    // Ocultar todos los textos primero
    document.querySelectorAll('.despacho-info').forEach(el => {
      el.classList.remove('is-active');
    });

    // Buscar cuál radio está seleccionado
    const selectedRadio = document.querySelector('input[name="enova-despacho"]:checked');
    
    if (selectedRadio) {
      // Obtener el ID del texto objetivo (data-target)
      const targetId = selectedRadio.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      
      // Si existe el elemento correspondiente, mostrarlo
      if (targetElement) {
        targetElement.classList.add('is-active');
      }
    }
  }

  // 3. Escuchar cambios en los radio buttons
  radios.forEach(radio => {
    radio.addEventListener('change', updateDespachoInfo);
  });

  // 4. Ejecutar una vez al inicio por si ya hay uno marcado por defecto
  updateDespachoInfo();
});



